<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showNewCategoria"
    no-close-on-backdrop
    size="sm"
    title="Agregar Categoria"
    cancel-variant="outline-secondary"
    @hidden="onlyClose"
  >
    <b-row>
      <b-col md="12" class="mt-1">
        <v-select
          placeholder="Seleccione Disciplina"
          :options="listDisciplinas"
          :clearable="false"
          style="width: 100%"
          v-model="disciplina"
        />
      </b-col>
      <b-col v-if="disciplina.value != ''" md="12" class="mt-2">
        <b-form-group label="Categoria a crearse" label-for="phone">
          <b-input-group>
            <b-input-group-prepend is-text>
              {{ disciplina.label }}
            </b-input-group-prepend>
            <b-form-input placeholder="Buscar" v-model="categoria" />

            <!-- <cleave
              id="phone"
              class="form-control"
              :raw="false"
              :options="opt"
              placeholder="Distintivo"
              v-model="categoria"
            /> -->
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <template #modal-footer>
      <div class="w-100">
        <template>
          <b-button
            variant="primary"
            class="float-right"
            @click="insertCategoria"
          >
            Agregar
          </b-button>
          <b-button
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cerrar
          </b-button>
        </template>
      </div>
    </template>
  </b-modal>
</template>
<script>
import store from '@/store'
import {
  BModal,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BInputGroupPrepend,
  BButton,
  // xx
} from 'bootstrap-vue'
import vSelect from 'vue-select'
// import Cleave from 'vue-cleave-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
import { ref } from '@vue/composition-api'
import apiCall from '../../utils/apiCall'
import { URL } from '../../utils/variables'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BFormInput,
    vSelect,
    BFormGroup,
    BInputGroup,
    // Cleave,
    BInputGroupPrepend,
    BButton,
  },
  props: {
    equipo: Object,
    // disciplina: Object,
    listDisciplinas: Array,
  },
  setup(props, { emit }) {
    // const categoriaAdmin = ref(null)
    const apodo = ref('')
    const opt = ref({
      blocks: [255],
      uppercase: true,
      delimiters: [' '],
    })
    const disciplina = ref({ label: 'Seleccione disciplina', value: '' })
    const categoria = ref(null)
    const { postApi } = apiCall()

    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      //   initModal()
      //   emit('recargar')
      store.commit('someVariables/UPDATE_SHOW_NEW_EQUIPO', false)
      props.equipo.categoria = null
      props.equipo.alias_equipo = ''
    }
    async function insertCategoria() {
      // console.log(categoria.value)
      // showLoadingPartidos.value = true
      if (disciplina.value.value === '') {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Seleccione la disciplina',
              icon: 'CheckIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          }
        )
      } else if (categoria.value === '' || categoria.value === null) {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Ingrese un nombre a la categoria',
              icon: 'CheckIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          }
        )
      } else {
        const path = 'ApiConfiguration/insertCategoria/'
        const data = {
          id_torneo:
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
          id_disciplina: disciplina.value.value,
          categoria: categoria.value,
        }
        // console.log(data)
        const response = await postApi(URL, path, data)
        if (response.flag === 'si') {
          emit('recargarCategorias')
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Creada exitosamente',
                icon: 'CheckIcon',
                variant: 'success',
                solid: true,
              },
            },
            {
              position: 'top-center',
              // eslint-disable-next-line
            }
          )
          disciplina.value = { label: 'Seleccione disciplina', value: '' }
          categoria.value = null
        } else {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: response.mensaje,
                icon: 'CheckIcon',
                variant: 'danger',
                solid: true,
              },
            },
            {
              position: 'top-center',
              // eslint-disable-next-line
            }
          )
        }
      }
      // showLoadingPartidos.value = false
      // console.log(partidos.value)
    }

    function onlyClose() {
      disciplina.value = { label: 'Seleccione disciplina', value: '' }
      store.commit('someVariables/UPDATE_SHOW_NEW_CATEGORIA', false)
      // props.equipo.categoria = null
      // props.equipo.alias_equipo = ''
    }
    return {
      resetModal,
      //   categoriaAdmin,
      //   apodo,
      apodo,
      opt,
      onlyClose,
      disciplina,
      categoria,
      insertCategoria,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
